import { useEffect } from "react";
import { applyJsonLd, buildSiteGraph } from "@/lib/seo";
import { useLiveClinic } from "@/lib/clinicLive";

/**
 * Mounts the site-wide JSON-LD @graph at the app root so every
 * route ships LocalBusiness + MedicalOrganization + Physician +
 * Service + FAQPage signals.
 *
 * Subscribes to the live clinic settings: whenever an admin saves
 * the settings panel the @graph is regenerated and the JSON-LD
 * <script> tag is rewritten in place.
 */
const SiteSchema = () => {
  const clinic = useLiveClinic();
  useEffect(() => {
    return applyJsonLd("site-graph", buildSiteGraph(clinic));
  }, [clinic]);
  return null;
};

export default SiteSchema;
